import React from "react";
// import { useStyles } from "./styles";
import ScrollableTabs from "../../../components/TabPanel/index";

function EarningDeviceView(props) {
  let {
    earningsModel,
    moduleName,
    timestamp,
    getColor,
    sectionName,
    data,
    others,
  } = props;
  return (
    <ScrollableTabs
      earningsModel={earningsModel}
      moduleName={moduleName}
      sectionHeader={earningsModel.sectionName}
      tabsDto={earningsModel.secTilesMasterTxDtos}
      sortingProperty="tileId"
      sortingOrder="asc"
      tabVariant="fullWidth"
      color={
        getColor[props.earningsModel && props.earningsModel.sectionName].color
      }
      timeStampArr={timestamp}
      // triggerFetchActivationDistributionTable={triggerFetchActivationDistributionTable}
      // triggerActivationDistributionCsv={triggerActivationDistributionCsv}
      {...others}
    />
  );
}

export default EarningDeviceView;
